
<div class="wtn-wrapper">
    <div class="wtn-intro">
        {{ "WTN.CTA.REGISTER_INTRO" | translate}}
    </div>
    <div class="wtn-cta">
        <div class="wtn-cta-img">
            <img src="/assets/images/wtn-logo-cta.png" />
        </div>
        <div class="wtn-cta-action">
            <button nbButton (click)="goToWtnLink()" status="primary" [size]="buttonSize">
                {{ "WTN.CTA.REGISTER" | translate }} <nb-icon icon="arrow-forward-outline"></nb-icon>
            </button>
        </div>
    </div>
</div>